import React, { useEffect, useState } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
// import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatCurrency,
  formatDate,
  formatDateTime,
  formatterStatus,
  formatterType,
  replaceNulls,
  sizePerPageList,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";

export const OrderTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  // const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      const newItem = replaceNulls(item);
      return {
        ...newItem,
        no: index + 1 + pageBefore,
      };
    });

    console.log(initData);
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const actionFormatter = (e, row) => {
    return (
      <Dropdown align="end">
        <Dropdown.Toggle
          variant="light"
          className="btn btn-sm d-flex align-items-center justify-content-center p-2"
          style={{
            borderRadius: "8px",
            width: "36px",
            height: "36px",
          }}
        >
          <i className="fas fa-pencil-alt" style={{ fontSize: "14px" }}></i>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() =>
              history.push(`/transaction/order/detail/${row.visit_order_id}`)
            }
          >
            <i className="fas fa-eye mr-2"></i>
            Detail
          </Dropdown.Item>

          {/* <Dropdown.Item
            onClick={() =>
              history.push(`/transaction/order/taking-order/${row.visit_order_id}`)
            }
          >
            <i className="fas fa-shopping-cart mr-2"></i>
            Taking Order
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>
    );
  };
  const columns = [
    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionFormatter,
    },
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "sales",
      dataField: "company_sales_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <b>{row.sales_person_code}</b>
            </span>
            <br />
            <span>{row.sales_person_name}</span>
            <br />
            <span>{row.username}</span>
          </div>
        );
      },
    },
    {
      text: "order no",
      dataField: "order_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
          >
            <NavLink
              className="menu-link"
              to={`/transaction/order/detail/${row.visit_order_id}`}
            >
              {cell}
            </NavLink>
          </span>
        );
      },
    },

    {
      text: "branch",
      dataField: "branch_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ref order no",
      dataField: "ref_order_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "order date",
      dataField: "order_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "140px" },
      formatter: formatDate,
    },
    {
      text: "customer",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <NavLink
                className="menu-link"
                to={`/master/customer/edit/${row.customer_id}`}
              >
                <b> {row.customer_code}</b> <br />{" "}
                <span>{row.customer_store_name}</span>
              </NavLink>
            </span>
          </div>
        );
      },
    },

    {
      text: "type",
      dataField: "customer_payment_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "80px" },
      formatter: formatterType,
    },

    {
      text: "order due date",
      dataField: "order_due_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "160px" },
      formatter: formatDate,
    },

    {
      text: "status",
      dataField: "status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
      formatter: formatterStatus,
    },

    {
      text: "order amount",
      dataField: "order_total",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "return amount",
      dataField: "order_retur",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },

    {
      text: "final amount",
      dataField: "order_final",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },

    {
      text: "sum paid",
      dataField: "order_sum_paid",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "remaining amount",
      dataField: "order_remain",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };
  return (
    <>
      <BootstrapTable
        remote
        striped
        noDataIndication="Data Not Found"
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={true}
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
